import { DrillDownRequestTypes } from "../../../../../infrastructure/enums";

const DRILLDOWN_PATH = "dashboard-drilldown-report";

export const DASHBOARD_DRILLDOWN_TARGETS: Record<string, DrillDownRequestTypes> = {
  "total-population": DrillDownRequestTypes.total_population_covered_by_asha,
  "total-total_population_assigned_to_asha": DrillDownRequestTypes.total_population_covered_by_asha,
  "children_0_5_yeras": DrillDownRequestTypes.children_0_to_6_yeras,
  "no_of_familes": DrillDownRequestTypes.no_of_familes,
  "member_above_30_years": DrillDownRequestTypes.member_above_30_years,

  // "family-approved": DrillDownRequestTypes.family_registration_approved,
  // "family-pending": DrillDownRequestTypes.family_registration_pending,
  // "family-native": DrillDownRequestTypes.family_registration_native,
  // "family-migrated": DrillDownRequestTypes.family_registration_migrated,

  // "anc-registered": DrillDownRequestTypes.anc_registered,
  // "anc-due-this-week": DrillDownRequestTypes.anc_due_this_week,
  // "anc-high-risk": DrillDownRequestTypes.anc_high_risk,
  // "anc-low-risk": DrillDownRequestTypes.anc_low_risk,

  // "pnc-deliveries": DrillDownRequestTypes.pnc_deliveries,
  // "pnc-visits-due": DrillDownRequestTypes.pnc_visits_due,
  // "pnc-referred-maata": DrillDownRequestTypes.pnc_referred_maata,
  // "pnc-completed": DrillDownRequestTypes.pnc_completed,

  // "hbnc-total-birth": DrillDownRequestTypes.hbnc_total_birth,
  // "hbnc-govt-hospital-birth": DrillDownRequestTypes.hbnc_govt_hospital_birth,
  // "hbnc-pre-mature-baby": DrillDownRequestTypes.hbnc_pre_mature_baby,
  // "hbnc-disabled-children": DrillDownRequestTypes.hbnc_disabled_children,
  // "hbnc-schedule-not-complete": DrillDownRequestTypes.hbnc_schedule_not_complete,

  // "ecr-eligible": DrillDownRequestTypes.ecr_eligible,
  // "ecr-infertile": DrillDownRequestTypes.ecr_infertile,
  // "ecr-using": DrillDownRequestTypes.ecr_using,
  // "ecr-not-using": DrillDownRequestTypes.ecr_not_using,

  // "birth-total": DrillDownRequestTypes.birth_total,
  // "birth-still": DrillDownRequestTypes.birth_still,
  // "birth-male": DrillDownRequestTypes.birth_male,
  // "birth-female": DrillDownRequestTypes.birth_female,

  // "immunization-fully": DrillDownRequestTypes.immunization_fully,
  // "immunization-zero-dose": DrillDownRequestTypes.immunization_zero_dose,
  // "immunization-started-not-completed": DrillDownRequestTypes.immunization_started_not_completed,
  // "immunization-partial": DrillDownRequestTypes.immunization_partial,

  // "death-total": DrillDownRequestTypes.death_total,
  // "death-0-to-5": DrillDownRequestTypes.death_0_to_5,
  // "death-pnc": DrillDownRequestTypes.death_pnc,
  // "death-30-plus": DrillDownRequestTypes.death_30_plus,
};

export const DRILLDOWN_ROUTE_PATH = DRILLDOWN_PATH;